import gql from "graphql-tag";

export const CREATE_TASK = gql`
  mutation AddTask($data: TaskDataInput) {
    addTask(data: $data) {
      id
    }
  }
`;

export const UPDATE_TASK = gql`
  mutation UpdateTask($data: TaskDataInput, $where: TaskWhereInput) {
    updateTask(data: $data, where: $where) {
      id
    }
  }
`;

export const TERMINATE_TASK = gql`
  mutation TerminateTask($data: TaskDataInput, $where: TaskWhereInput) {
    terminateTask(data: $data, where: $where) {
      id
      status
    }
  }
`;

export const DELETE_TASK = gql`
  mutation DeleteTask($where: TaskWhereInput) {
    deleteTask(where: $where) {
      id
    }
  }
`;

export const CANCEL_TASK_REMINDER = gql`
  mutation CancelTaskReminder($where: TaskWhereInput) {
    cancelTaskReminder(where: $where) {
      id
      reminderCancelled
    }
  }
`;

export const REACTIVATE_TASK_REMINDER = gql`
  mutation ReactivateTaskReminder($where: TaskWhereInput) {
    reactivateTaskReminder(where: $where) {
      id
      reminderCancelled
    }
  }
`;

const tasks = {
  CREATE_TASK,
  UPDATE_TASK,
  DELETE_TASK,
  TERMINATE_TASK,
  CANCEL_TASK_REMINDER,
  REACTIVATE_TASK_REMINDER,
};

export default tasks;
